@if (!!customForm()) {
  <div #formContainer></div>
} @else if (customForm() === null) {
  <!-- Nothing -->
} @else if (!onlySpecialCaseCapabilities()) {
  <ai-capability-form
    [capabilityForm]="capabilityForm()"
    (toolFormDisplay)="
      toolFormDisplay.emit($event !== undefined ? { form: $event, parentCapabilityForm: capabilityForm() } : undefined)
    "
  />
}
